import { useEffect, useState } from "react";
import { PhoneCall, Mail, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { COMPANY, ADDRESS_LINE } from "@/lib/company";

// Shared public footer: one sales contact block (public company phone · email) + legal links. No blog link until there are posts.
export default function PublicFooter() {
  const [rep, setRep] = useState({});
  useEffect(() => { api.get("/sales-rep").then((r) => setRep(r.data || {})).catch(() => {}); }, []);
  const phone = rep.phone || "+1-325-221-4234";
  const email = rep.email || "sales@arcadeops.net";
  return (
    <footer className="border-t border-border/60 bg-black/40" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 py-8 grid md:grid-cols-3 gap-6">
        <div className="text-[11px] font-mono text-muted-foreground leading-relaxed">
          &copy; {new Date().getFullYear()} Arcade Ops
          <span className="block mt-1 text-white/40">Arcade Ops is a marketing, technology and lead-operations platform. It does not own or operate gaming equipment.</span>
        </div>
        <div className="font-mono text-xs space-y-1.5" data-testid="footer-contact">
          <a href={`tel:${phone}`} data-testid="footer-phone" className="flex items-center gap-2 text-neon-yellow hover:text-white"><PhoneCall className="w-3.5 h-3.5" /> Call · {phone}</a>
          <a href={`mailto:${email}`} data-testid="footer-email" className="flex items-center gap-2 text-neon-cyan hover:text-white"><Mail className="w-3.5 h-3.5" /> {email}</a>
          <address className="not-italic flex items-start gap-2 text-white/60 pt-1" data-testid="footer-address"><MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {ADDRESS_LINE}</address>
        </div>
        <div className="flex flex-wrap md:justify-end items-start gap-x-4 gap-y-2 text-[11px] font-mono uppercase tracking-widest">
          <a href="/about" data-testid="footer-about" className="text-muted-foreground hover:text-neon-cyan">About</a>
          <a href="/pricing" className="text-muted-foreground hover:text-neon-cyan">Pricing</a>
          <a href="/states" data-testid="footer-states" className="text-muted-foreground hover:text-neon-cyan">States</a>
          <a href="/fortune" className="text-muted-foreground hover:text-neon-cyan">For venues</a>
          <a href="/blog" data-testid="footer-blog" className="text-muted-foreground hover:text-neon-cyan">Blog</a>
          <a href="/privacy" className="text-muted-foreground hover:text-neon-cyan">Privacy</a>
          <a href="/terms" className="text-muted-foreground hover:text-neon-cyan">Terms</a>
          <a href="/sms-consent" className="text-muted-foreground hover:text-neon-cyan">SMS terms</a>
          <button type="button" data-testid="footer-manage-cookies" onClick={() => window.dispatchEvent(new Event("arcadeops:cookies:reopen"))} className="text-muted-foreground hover:text-neon-cyan uppercase tracking-widest">Cookies</button>
        </div>
      </div>
    </footer>
  );
}
